<h2 mat-dialog-title translate style="margin: 0px">Report Folders</h2>



<mat-dialog-content>

    <!-- Angular Material table definition -->
    <mat-table #table [dataSource]="angularMatData" style="width: 100%;" multiTemplateDataRows matSortDisableClear>
        <!-- Individual column definitions -->
        <ng-container matColumnDef="ReportFolderName">
            <mat-header-cell *matHeaderCellDef  translate
                >Folder
            </mat-header-cell>
            <mat-cell *matCellDef="let Folder"  >
                {{Folder.Name}}
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="Description">
            <mat-header-cell *matHeaderCellDef  translate
                >Description
            </mat-header-cell>
            <mat-cell *matCellDef="let Folder"  >
                {{Folder.Description}}
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="Total">
            <mat-header-cell *matHeaderCellDef  translate
                >Total Reports
            </mat-header-cell>
            <mat-cell *matCellDef="let Folder" >
                {{Folder.Reports.length}}
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="Actions">
            <mat-header-cell *matHeaderCellDef  translate >Actions
            </mat-header-cell>
            <mat-cell *matCellDef="let Folder" >
                <div style="width:100%; text-align:center;">
                    <img [matMenuTriggerFor]="settingsMenu" yPosition="below" alt="Actions"
                        src="./assets/images/actions.png" style="height:30px; width:30px;" />
                </div>
                <mat-menu #settingsMenu="matMenu" [overlapTrigger]="false">
                    <div mat-menu-item style="line-height:normal;" (click)="folderEditClick(Folder)">
                        <span style="font-size:10pt;cursor:pointer;">Edit</span>
                    </div>
                    <div mat-menu-item style="line-height:normal;padding-top:5px;" (click)="folderDeleteClick(Folder)">
                        <span style="font-size:10pt;cursor:pointer;">Delete</span>

                    </div>
                </mat-menu>
            </mat-cell>
        </ng-container>
    

    <ng-container>
        <!-- Row definitions determine what will actually be displayed -->
        <!-- Styles set here will apply to all cells in the row -->
        <!-- Header row -->
        <mat-header-row *matHeaderRowDef="columnsToDisplay;" id="ReportsFolders" style="font-weight: bold;">
        </mat-header-row>
        <!-- Data rows -->
        <mat-row *matRowDef="let row; columns: columnsToDisplay; let i = index;" id="MRdataRow{{i}}" tabindex="0"
            
            style="min-width: 500px;" matRipple
           >
        </mat-row>
    </ng-container>

</mat-table>
    <!-- old table  -->
    <!-- <table class="table" style="width:100%;">
        <tr>
           
            <th style="width:150px;padding-left:10px;">Folder</th>
            <th style="width:200px;padding-left:20px;">Description</th>
            <th style="width:150px;padding-right:30px; text-align:right;">Total Reports</th>
            <th style="width:50px; text-align:center;">Actions</th>
        </tr>
        <tr style="line-height:25px;" *ngFor="let Folder of reportFolders">

            <td style="white-space:nowrap;padding-left:10px;">{{Folder.Name}}</td>
            <td style="white-space:nowrap;padding-left:2px;">{{Folder.Description}}</td>
            <td style="white-space:nowrap;padding-right:30px;text-align:right;">{{Folder.Reports.length}}</td>
            <td style="text-align:center;  width:120px;">
                <div style="width:100%; text-align:center;">
                    <img [matMenuTriggerFor]="settingsMenu" yPosition="below" alt="Actions"
                        src="./assets/images/actions.png" style="height:30px; width:30px;" />
                </div>
                <mat-menu #settingsMenu="matMenu" [overlapTrigger]="false">
                    <div mat-menu-item style="line-height:normal;" (click)="folderEditClick(Folder)">

                        <span style="font-size:10pt;cursor:pointer;">Edit</span>

                    </div>
                    <div mat-menu-item style="line-height:normal;padding-top:5px;" (click)="folderDeleteClick(Folder)">


                        <span style="font-size:10pt;cursor:pointer;">Delete</span>

                    </div>
                </mat-menu>
            </td>



        </tr>
    </table> -->

</mat-dialog-content>


<!-- Dialog Footer -->
<mat-dialog-actions>
    <div class='flex-footer-left' style="align-items: center; width: 50%">
        <tyl-button image="add.png" translate label="Add Folder" (clickEvent)="addFolderClick()"></tyl-button>

    </div>
    <div class='flex-footer-right' style="align-items: center; width: 50%">
        <tyl-button image="cancel.png" translate label="Close" (clickEvent)="closeClick()"></tyl-button>
        <!-- style="float:right; color: white;" -->
    </div>
</mat-dialog-actions>